import React, { SyntheticEvent } from 'react';
import { MusicAlbumEntity, MusicAlbumTrackEntity } from '../../types/MusicAlbumEntityTypes';

export default function MusicAlbumReleaseStepsView({
  musicAlbum,
  step,
  onClick,
} : {
  musicAlbum: MusicAlbumEntity & {
    music_album_tracks: MusicAlbumTrackEntity[],
  },
  step: number,
  onClick: (callback: (musicAlbumId: number) => void) => void,
}) {

  const isStepIncomplete = (currentStep: number) => {
    if (currentStep === 1) {
      if (!musicAlbum) return false;
      if (!musicAlbum.id) return false;
      if (!musicAlbum.is_distributable || !musicAlbum.exists_album_image) return true;
      return false;
    } if (currentStep === 2) {
      if (!musicAlbum) return false;
      if (!musicAlbum.id) return false;
      if (!musicAlbum.is_distributable || !musicAlbum.exists_album_image) return false;
      if (!musicAlbum.music_album_tracks) return false;
      if (musicAlbum.music_album_tracks.length === 0) return false;
      return false;
    } if (currentStep === 3) {
      if (!musicAlbum) return false;
      if (!musicAlbum.id) return false;
      if (!musicAlbum.is_distributable || !musicAlbum.exists_album_image) return false;
      if (!musicAlbum.music_album_tracks) return false;
      if (musicAlbum.music_album_tracks.length === 0) return false;
      // eslint-disable-next-line max-len
      if (musicAlbum.music_album_tracks.filter((musicAlbumTrack) => !musicAlbumTrack.is_distributable).length > 0) return true;
      return false;
    } if (currentStep === 4) {
      if (!musicAlbum) return false;
      if (!musicAlbum.id) return false;
      if (!musicAlbum.is_distributable || !musicAlbum.exists_album_image) return false;
      if (!musicAlbum.music_album_tracks) return false;
      if (musicAlbum.music_album_tracks.length === 0) return false;
      // eslint-disable-next-line max-len
      if (musicAlbum.music_album_tracks.filter((musicAlbumTrack) => !musicAlbumTrack.is_distributable).length > 0) return false;
      return false;
    }
    return false;
  };

  const isStepCompleted = (currentStep: number) => {
    if (currentStep === 1) {
      if (!musicAlbum) return false;
      if (!musicAlbum.id) return false;
      if (!musicAlbum.is_distributable || !musicAlbum.exists_album_image) return false;
      return true;
    } if (currentStep === 2) {
      if (!musicAlbum) return false;
      if (!musicAlbum.id) return false;
      if (!musicAlbum.is_distributable || !musicAlbum.exists_album_image) return false;
      if (!musicAlbum.music_album_tracks) return false;
      if (musicAlbum.music_album_tracks.length === 0) return false;
      return true;
    } if (currentStep === 3) {
      if (!musicAlbum) return false;
      if (!musicAlbum.id) return false;
      if (!musicAlbum.is_distributable || !musicAlbum.exists_album_image) return false;
      if (!musicAlbum.music_album_tracks) return false;
      if (musicAlbum.music_album_tracks.length === 0) return false;
      // eslint-disable-next-line max-len
      if (musicAlbum.music_album_tracks.filter((musicAlbumTrack) => !musicAlbumTrack.is_distributable).length > 0) return false;
      return true;
    } if (currentStep === 4) {
      if (!musicAlbum) return false;
      if (!musicAlbum.id) return false;
      if (!musicAlbum.is_distributable || !musicAlbum.exists_album_image) return false;
      if (!musicAlbum.music_album_tracks) return false;
      if (musicAlbum.music_album_tracks.length === 0) return false;
      // eslint-disable-next-line max-len
      if (musicAlbum.music_album_tracks.filter((musicAlbumTrack) => !musicAlbumTrack.is_distributable).length > 0) return false;
      return true;
    }
    return false;
  };

  const getClassNameForIndex = (index: number) => {
    if (isStepCompleted(index)) {
      return (index === step) ? 'current' : 'ok';
    } if (isStepIncomplete(index)) {
      return 'note';
    }
    return (index === step) ? 'current' : 'off';
  };

  const cancelEvent = (e: SyntheticEvent) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const handleClick = (index: number) => {
    const className = getClassNameForIndex(index);
    if (className !== 'off') {
      onClick((musicAlbumId) => {
        if (index === 1) {
          document.location.href = `/music_albums/edit/${musicAlbumId}`;
        } else if (index === 2) {
          document.location.href = `/music_albums/select_tracks/${musicAlbumId}`;
        } else if (index === 3) {
          document.location.href = `/music_albums/edit_tracks/${musicAlbumId}`;
        } else if (index === 4) {
          document.location.href = `/music_albums/confirm/${musicAlbumId}`;
        }
      });
    }
  };

  return (
    <ul className="step_box">
      <li className={getClassNameForIndex(1)}>
        <a href={`/music_albums/edit/${musicAlbum.id}`} onClick={(e) => { cancelEvent(e); handleClick(1); }}>
          <div />
          <span>リリース情報の入力</span>
        </a>
      </li>
      <li className={getClassNameForIndex(2)}>
        <a href={`/music_albums/select_tracks/${musicAlbum.id}`} onClick={(e) => { cancelEvent(e); handleClick(2); }}>
          <div />
          <span>曲を選ぶ</span>
        </a>
      </li>
      <li className={getClassNameForIndex(3)}>
        <a href={`/music_albums/edit_tracks/${musicAlbum.id}`} onClick={(e) => { cancelEvent(e); handleClick(3); }}>
          <div />
          <span>曲情報の入力</span>
        </a>
      </li>
      <li className={getClassNameForIndex(4)}>
        <a href={`/music_albums/confirm/${musicAlbum.id}`} onClick={(e) => { cancelEvent(e); handleClick(4); }}>
          <div />
          <span>確認</span>
        </a>
      </li>
    </ul>
  );
}
